module.exports = __webpack_public_path__ + "static/media/donut_chart_empty.4672e9bd.svg";